<!--
 * @Author: your name
 * @Date: 2021-05-25 17:00:33
 * @LastEditTime: 2021-05-28 13:39:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \VtpWechatUI\src\components\IndexBefor.vue
-->
<template>
    <div class=""></div>
</template>

<script>
import Qs from 'qs'
import { getAction } from '../request/http'
export default {
    components: {},
    data() {
        return {

        }
    },
    computed: {},
    watch: {},
    methods: {},
    created() {
        const query = Qs.parse(location.search.substring(1))
        var code = query.code
        // var code = '9927'
        // this.token = code
        getAction("/oauthWechatCheck/getWebToken", { code: code }).then((res) => {
            this.$store.commit('refreshToken', res.data.access_token)
            this.$store.commit('saveOpenid', res.data.openid)
            this.$router.push('/index')
        })
    },
    mounted() { },
    beforeCreate() { },
    beforeMount() { },
    beforeUpdate() { },
    updated() { },
    beforeDestroy() { },
    destroyed() { },
    activated() { }
}
</script>
<style  scoped>
</style>



// WEBPACK FOOTER //
// src/components/IndexBefor.vue